export const notification = {
    namespaced: true,
    state: {
        active: false,
        message: '',
    },
    mutations: {
        hide(state) {
            state.active = false;
        },
        show(state, message) {
            state.message = message;
            state.active = true;
        }
    },
    actions: {
        hide({ commit }) {
            commit('hide');
        },
        show({ commit }, message) {
            commit('show', message);
            setTimeout(() => {
                commit('hide');
            }, 10000);
        },
    },
}


// WEBPACK FOOTER //
// ./src/modules/notification/store.js